export class TenantInfoApplications {
  description: string;
  id: number;
  name: string;
  type: number;
  active: boolean;
  tenantId: string;
  workfowsModuleEnabled: boolean;
}
